<!-- BOTÓN HEADER -->
<div class="documentos-historicos container-fluid p-3" [ngStyle]="isLoading ? {'min-height.px': 40, 'background': '#DAEAFB', 'border': 'none'} : {}">
  <div class="col" style=" min-height: 40px !important;" *ngIf="isLoading">
    <div class="loader">
      <div class="loader__figure"></div>
      <p class="loader__label"></p>
    </div>
  </div>
  <ng-container *ngIf="!isLoading">

  <div class="header-documentos d-flex justify-content-between align-items-center mb-2">
    <div class="d-flex align-items-center">
      <i class="fi fi-rr-folder "></i>
      <span class="titulo-header">Documentos</span>
    </div>

   <button
  type="button"
  class="btn-filtros"
  [ngClass]="{ 'btn-filtros-activo': hasFiltrosActivos() }"
  (click)="mostrarFiltros = !mostrarFiltros"
>
  <i class="d-flex mr-1 fi fi-rr-filter"></i>
  Filtros
</button>

  </div>

  <hr class="mt-0 mb-2">

  <!-- OVERLAY + PANEL DE FILTROS -->
  <div *ngIf="mostrarFiltros" class="filtros-overlay" (click)="cerrarFiltros()">

    <!-- Evita que el click dentro del panel cierre el overlay -->
    <div class="dropdown-filtros" (click)="$event.stopPropagation()">
      <div class="filtros-header">
        <span>Filtros</span>
       <button
  type="button"
  class="btn-filtros"
  [ngClass]="{ 'btn-filtros-activo': hasFiltrosActivos() }"
  (click)="mostrarFiltros = !mostrarFiltros"
>
  <i class="d-flex mr-1 fi fi-rr-filter"></i>
  Filtros
</button>


      </div>

      <hr class="filtro-separator">

      <!-- Origen del documento -->
      <div class="filtro-section">
        <div class="filtro-label">Origen del documento</div>

        <div class="form-check mb-1">
          <input class="form-check-input" type="checkbox" id="chkOrigenGen" [(ngModel)]="filtros.origenGeneradoTratante"
            (ngModelChange)="filterDocs()">
          <label class="form-check-label" for="chkOrigenGen">
            Generados en consulta
          </label>
        </div>

        <div class="form-check mb-1">
          <input class="form-check-input" type="checkbox" id="chkOrigenSubTrat"
            [(ngModel)]="filtros.origenSubidoTratante" (ngModelChange)="filterDocs()">
          <label class="form-check-label" for="chkOrigenSubTrat">
            Subido por profesional
          </label>
        </div>

        <div class="form-check mb-1">
          <input class="form-check-input" type="checkbox" id="chkOrigenSubPac"
            [(ngModel)]="filtros.origenSubidoPaciente" (ngModelChange)="filterDocs()">
          <label class="form-check-label" for="chkOrigenSubPac">
            Subido por paciente
          </label>
        </div>
      </div>

      <hr class="filtro-separator">

      <!-- Rango de fechas -->
      <div class="filtro-section">
        <div class="filtro-label">Rango de fechas</div>
        <input type="date" class="form-control filtro-input mb-2" placeholder="Desde" [(ngModel)]="filtros.fechaDesde"
          (change)="filterDocs()">

        <input type="date" class="form-control filtro-input" placeholder="Hasta" [(ngModel)]="filtros.fechaHasta"
          (change)="filterDocs()">
      </div>

      <hr class="filtro-separator">

      <!-- Tipo de documento -->
      <div class="filtro-section">
        <div class="filtro-label">Tipo de documento</div>

        <div class="form-check mb-1" *ngFor="let t of tiposDocumento; let i = index">
          <input class="form-check-input" type="checkbox" [id]="'chkTipo' + i" [checked]="isTipoSelected(t)"
            (change)="toggleTipo(t, $event.target.checked)">
          <label class="form-check-label" [for]="'chkTipo' + i">
            {{ t }}
          </label>
        </div>
      </div>

      <hr class="filtro-separator">

      <!-- Buscar por nombre -->
      <div class="filtro-section">
        <div class="filtro-label">Buscar por nombre</div>
        <input type="text" class="form-control filtro-input" placeholder="Buscar por nombre"
          [(ngModel)]="filtros.nombre" (keyup)="filterDocs()">
      </div>

      <div class="filtro-actions mt-2">
        <button class="btn-limpiar mr-2" (click)="limpiarFiltros()">
          Limpiar
        </button>
        <button class="btn-aplicar" (click)="aplicarFiltros()">
          Cerrar
        </button>
      </div>
    </div>
  </div>

  <!-- TABLA -->
  <div class="table-responsive">
    <table class="table table-sm custom-table m-0">
      <thead class="tabla-docs">
        <tr>
          <th>Nombre</th>
          <!-- Fecha solo desde md hacia arriba -->
          <th class="d-none d-md-table-cell">Fecha</th>
          <th>Autor</th>
          <th class="text-right"></th>
        </tr>
      </thead>
      <ng-container *ngIf="documentosFiltradosUI.length > 0">

      <tbody>
        
          <tr *ngFor="let doc of documentosFiltradosUI; let i = index" [ngClass]="{ 'row-alt': (i % 2 === 1) }" >
  
            <!-- Nombre + tipo (+ fecha en mobile) -->
            <td>
              <div class="d-flex align-items-center">
                <div class="d-flex align-items-center justify-content-center">
                  <i class="fi fi-rr-document"></i>
                </div>
                <div class="nombre-doc ml-2">
                  <div class="nombre-principal">
                    {{ getDocNombreMostrar(doc) }}
                  </div>
                  <div class="nombre-secundario">
                    {{ doc.tipo_doc || doc.att_typ_name | titlecase }}
                  </div>
                  <!-- Fecha debajo del tipo SOLO en mobile -->
                  <div class="fecha-mobile d-block d-md-none text-muted">
                    {{ formatFecha(doc.att_date_doc || doc.att_date) }}
                  </div>
                </div>
              </div>
            </td>
  
            <!-- Fecha en columna (solo md+) -->
            <td class="align-middle d-none d-md-table-cell">
              {{ formatFecha(doc.att_date_doc || doc.att_date) }}
            </td>
  
            <!-- Autor -->
            <td class="align-middle">
              {{
              doc.upload_by == 1
              ? 'Dr(a).' + doc.nombreMedico
              : doc.upload_by == 2
              ? 'Dr(a).' + doc.nombreMedico
              : 'Paciente'
              }}
            </td>
  
            <!-- Descargar -->
            <td class="text-right align-middle">
              <i class="fi fi-rr-download cursor-pointer" (click)="descargarDoc(doc)"></i>
            </td>
          </tr>
          
        </tbody>
        </ng-container>
        <tbody>
          <tr *ngIf="documentosFiltradosUI.length === 0">

            <td colspan="4" class="text-center p-3">
              <span>
No existen documentos previos.
              </span>
            </td>
          </tr>
        </tbody>
       

       
    </table>
  </div>
  </ng-container>
  
</div>